<div class="destination-filter" *ngIf="filters?.length > 0 && (company$ | async) as company">
  <div class="destination-filter__header">
    <h3>Filter</h3>
    <lx-button
      text="Clear Filter"
      (buttonClick)="clearFilter()"
      buttonStyle="primary"
      size="s"
      [btnRounded]="true"
      [ngClass]="'lx-button--' + company | lowercase"
    ></lx-button>
  </div>
  <p-tree
    [value]="filters"
    selectionMode="checkbox"
    [(selection)]="selectedFilters"
    (onNodeSelect)="emitFiltersChanged()"
    (onNodeUnselect)="emitFiltersChanged()"
    [styleClass]="'destination-filter__tree destination-filter__tree__' + company | lowercase"
  ></p-tree>
</div>
